<template>
  <aside class="sidebar">
    <svg width="0" height="0" aria-hidden="true" focusable="false">
      <defs>
        <linearGradient id="bg-side-nav-gold" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stop-color="#fff8df" />
          <stop offset="38%" stop-color="#f0d06a" />
          <stop offset="100%" stop-color="#c8942e" />
        </linearGradient>
        <linearGradient id="bg-side-nav-gold-soft" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stop-color="#fff2c4" stop-opacity="0.28" />
          <stop offset="100%" stop-color="#b8872a" stop-opacity="0.08" />
        </linearGradient>
      </defs>
    </svg>

    <nav class="side-nav">
      <a
        v-for="item in menuItems"
        :key="item.key"
        href="#"
        class="side-item"
        :class="{
          active: activeSide === item.key,
          'side-item--new': hasNewBadge(item)
        }"
        @click.prevent="$emit('nav', item.key)"
      >
        <span class="side-item__icon" aria-hidden="true">
          <span
            v-if="hasNewBadge(item)"
            class="side-item__new-badge"
            :aria-label="$t('nav.newBadgeAria')"
          >{{ $t('nav.newBadge') }}</span>
          <span class="side-item__icon-tile">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                v-for="(path, index) in iconPaths(item.icon)"
                :key="index"
                :d="path.d"
                :fill="path.fill || 'none'"
                :stroke="path.stroke || 'none'"
                :stroke-width="path.strokeWidth || 1.4"
                :stroke-linecap="path.strokeLinecap || 'round'"
                :stroke-linejoin="path.strokeLinejoin || 'round'"
                :opacity="path.opacity != null ? path.opacity : 1"
              />
            </svg>
          </span>
        </span>
        <b class="side-item__label">
          <span class="side-item__label-text">{{ item.label }}</span>
          <span
            v-if="menuBadgeCount(item.key) > 0"
            class="side-item__badge"
            :aria-label="$t('slip.unreadAria', { count: menuBadgeCount(item.key) })"
          >{{ menuBadgeLabel(item.key) }}</span>
        </b>
      </a>
    </nav>

    <BlackGoldJackpotBox />

    <div class="sidebar-banners">
      <button
        type="button"
        class="sidebar-banner sidebar-banner--telegram"
        @click="onTelegramClick"
      >
        <img :src="telegramBannerUrl" :alt="$t('nav.telegramInquiry')" loading="lazy" decoding="async">
      </button>
      <button
        v-if="showTetherGuideButton"
        type="button"
        class="sidebar-banner sidebar-banner--tether-inquiry"
        @click="onTetherGuideClick"
      >
        <img
          :src="tetherInquiryBannerUrl"
          :alt="$t('sidebar.tetherGuideTitle')"
          loading="lazy"
          decoding="async"
        >
      </button>
    </div>

    <BlackGoldAgeRestriction />
  </aside>
</template>

<script>
import { BLACK_GOLD_DATA } from '@/data/blackGoldSite'
import BlackGoldJackpotBox from '@/components/black-gold/BlackGoldJackpotBox.vue'
import BlackGoldAgeRestriction from '@/components/black-gold/BlackGoldAgeRestriction.vue'
import { getTelegramInquiryBannerUrl } from '@/utils/siteBrand'
import { getSideMenuIconPaths } from '@/utils/sideMenuIcons'
import { paymentMethodAllowsTether, resolvePaymentMethod } from '@/utils/paymentMethod'
import { openTetherUsdtGuide, TETHER_INQUIRY_BANNER_URL } from '@/utils/tetherGuide'

export default {
  name: 'BlackGoldSidebar',
  components: { BlackGoldJackpotBox, BlackGoldAgeRestriction },
  props: {
    activeSide: { type: String, default: 'home' },
    telegramId: { type: String, default: '' },
    sideMenu: {
      type: Array,
      default: null
    },
    menuBadges: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    telegramBannerUrl () {
      return getTelegramInquiryBannerUrl(this.$i18n.locale)
    },
    tetherInquiryBannerUrl () {
      return TETHER_INQUIRY_BANNER_URL
    },
    showTetherGuideButton () {
      const siteInfo = this.$store.state.siteInfo
      if (!siteInfo) return false
      return paymentMethodAllowsTether(resolvePaymentMethod(siteInfo))
    },
    menuItems () {
      if (Array.isArray(this.sideMenu) && this.sideMenu.length) {
        return this.sideMenu
      }
      return BLACK_GOLD_DATA.sideMenu
    }
  },
  methods: {
    iconPaths (icon) {
      return getSideMenuIconPaths(icon)
    },
    onTelegramClick () {
      this.$emit('telegram')
    },
    onTetherGuideClick () {
      openTetherUsdtGuide()
    },
    menuBadgeCount (key) {
      const value = Number(this.menuBadges && this.menuBadges[key])
      if (!Number.isFinite(value) || value <= 0) return 0
      return Math.floor(value)
    },
    menuBadgeLabel (key) {
      const count = this.menuBadgeCount(key)
      if (count <= 0) return ''
      return count > 99 ? '99+' : String(count)
    },
    hasNewBadge (item) {
      return !!(item && item.newBadge)
    }
  }
}
</script>
